import { DestroyRef, Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChavePermissao } from '../../../core/api/sicom-api/portal/permissao/permissao.model';
import { PermissaoService } from '../../../core/api/sicom-api/portal/permissao/permissao.service';

@Directive({
    selector: '[appPermissao]',
    standalone: true
})
export class AppPermissaoDirective implements OnInit {
    @Input('appPermissao') chave!: ChavePermissao;
    @Input('appPermissaoValor') valor!: string;

    private readonly templateRef = inject(TemplateRef<unknown>);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly permissaoService = inject(PermissaoService);
    private readonly destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this.permissaoService
            .verificar(this.chave, this.valor)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((temPermissao) => {
                this.viewContainer.clear();
                if (temPermissao) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                }
            });
    }
}
